<template>
  <div class="d-flex">
    <div
      style="height: 100vh; width: 100%;"
      class="d-flex align-center justify-center"
    >
      <div style="width: 400px">
        <h1
          class="text-center font-weight-bold darkBlue--text font-weight-bold mb-7"
        >
          Sign In
        </h1>
        <v-form>
          <v-col class="pb-0">
            <v-text-field
              v-model="username"
              label="Email address"
              hide-details="auto"
              solo
              flat
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="userpswd"
              label="Password"
              hide-details="auto"
              type="password"
              solo
              flat
            ></v-text-field>
          </v-col>

          <v-col class="py-0">
            <v-btn
              :disabled="isButtonDisabled"
              block
              depressed
              color="#51A7F8"
              class="text-capitalize font-weight-black primary--text"
              height="42"
              @click="checkuserAuthenticate()"
            >
              <span class="white--text">Login</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-alert outlined v-if="ishaveerror" type="error">
              {{ this.apistatusmsg }}
            </v-alert>
          </v-col>
        </v-form>
      </div>
    </div>
    
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from "../apis/apifactory";

Vue.use(VueAxios, axios);
export default {
  name: "Login",
  data: () => ({
    userinfo: null,
    //username: 'manishdwivedi77@gmail.com',
    //userpswd: 'man@trigma2021',

    username: null,
    userpswd: null,

    userid: null,
    loginusername: null,
    apistatuscode: null,
    apistatusmsg: null,
    ishaveerror: false,
    isButtonDisabled: false,
  }),
  methods: {
    checkuserAuthenticate() {
      this.checkuserlogin();
      //this.checkuserloginnew();
    },
 checkuserloginnew() {
     localStorage.setItem("SET_USERNAME","manish");
              localStorage.setItem("SET_USERID","1");
              this.goTo("/allapps");
    },
    checkuserlogin() {
      apifactory
        .userAthenticate(this.username, this.userpswd)
        .then((res) => {
          this.userinfo = res.data;
          //alert(JSON.stringify(res.data));
            if (res.data.userID != null) {
               this.ishaveerror = false;
               this.userid=res.data.userID;
               this.loginusername=res.data.userName;
               //alert(JSON.stringify(res.data.userName));
              /*
              this.ishaveerror = false;
              this.apistatuscode = res.data.status;
              this.apistatusmsg = res.data.message;
              this.loginusername = res.data.username;
              this.userid = res.data.id;
*/
              localStorage.setItem("SET_USERNAME", this.loginusername);
              localStorage.setItem("SET_USERID", this.userid);
              this.goTo("/allapps");
              } else {
              this.apistatusmsg = "Try Again !";// res.data.message;
              this.ishaveerror = true;
            }
        })
        .catch(function(error) {
         alert(JSON.stringify(error));
        });
    },
    goTo(url) {
      return this.$router.push(url);
    },
  },
  mounted() {
    window.localStorage.clear();
  },
  watch: {
    username: function() {
      if (this.username.length > 0) {
        this.isButtonDisabled = false;
      } else {
        this.isButtonDisabled = true;
      }
      //this.selectedBrand = [];

      //alert('hello' + this.selectedCountry);
    },
  },
};
</script>
<style>
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f3f5f8 !important;
  border-radius: 8px !important;
  font-weight: 700;
}
</style>
